export enum RepaymentStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    DONE = 'DONE',
    SCHEDULED = 'SCHEDULED',
    PAST_DUE = 'PAST_DUE',
    PAID = 'PAID',
    NOT_PAID = 'NOT_PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    CANCELED = 'CANCELED',
}
